<template>
  <div class="bg_gray">
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
            <div class="search_con m_flex_box flex_vc">
              <van-icon name="search" />
              <input
                class="middle"
                type="text"
                v-model="itemName"
                placeholder="搜索"
                @keyup.enter="submit"
              />
            </div>
          </div>
          <p
            class="header_address m_flex_box flex_vc"
            @click="showPicker = true"
          >
            <span>认购状态:</span>
            <span>{{ state }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <div class="tab_con m_flex_box flex_vb">
      <span :class="tab === 0 ? 'active' : ''" @click="changeTab(0)"
        >第一批次</span
      >
      <span :class="tab === 1 ? 'active' : ''" @click="changeTab(1)"
        >第二批次</span
      >
      <span :class="tab === 2 ? 'active' : ''" @click="changeTab(2)"
        >第三批次</span
      >
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="no_data" v-if="!list.length">
          <img src="@/assets/img/nodata.png" alt="" />
        </div>
        <div class="inner bor_b" v-for="(item, index) in list" :key="index">
          <div class="top m_flex_box flex_vc flex_jz">
            <h5 class="line_comp1">
              选房序号:{{ item.seq ? item.seq : "-" }}
            </h5>
            <h5 class="line_comp1">
              报名序号:{{ item.applyNo ? item.applyNo : "-" }}
            </h5>
            <p>
              <span>认购状态:</span
              ><span>{{ item.choiceType ? item.choiceType : "-" }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              姓 名：<span>{{ item.userName ? item.userName : "-" }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              手 机 号：<span>{{ item.phone ? item.phone : "-" }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              证件类型：<span>{{
                item.idCardType ? item.idCardType : "-"
              }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              证 件 号：<span>{{ item.idCardNo ? item.idCardNo : "-" }}</span>
            </p>
          </div>
          <!-- <div class="row">
            <p class="m_flex_box">
              报名时间：<span>{{
                item.createDate ? item.createDate : "-"
              }}</span>
            </p>
          </div> -->
          <div class="row">
            <p class="m_flex_box">
              人员类型：<span>{{
                item.talentType ? item.talentType : "-"
              }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              认购时间：<span>{{
                item.preBuyDate ? item.preBuyDate : "-"
              }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              选购房源：<span>{{ item.houseInfo ? item.houseInfo : "-" }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              婚姻状况:<span>{{
                item.marryStatus ? item.marryStatus : "-"
              }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              无房验证状态：
              <span>{{
                item.houseStatus == 0
                  ? "无需验证"
                  : item.houseStatus == 1
                  ? "待确认"
                  : item.houseStatus == 2
                  ? "通过"
                  : item.houseStatus == 3
                  ? "未通过"
                  : "-"
              }}</span>
            </p>
          </div>
          <div class="row">
            <p class="m_flex_box">
              是否入围：
              <span>{{
                item.sfyz == 0 ? "候选" : item.sfyz == 1 ? "入围" : "-"
              }}</span>
            </p>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="rgArray"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import topHeader from "@/components/header";
import qs from "qs";
export default {
  data() {
    return {
      definition: "人才",
      tab: 0,
      state: "全部",
      choiceType: "",
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      saleItemId: this.$route.query.saleItemId,
      pageIndex: 1,
      timer: null,
      itemName: "",
      showPicker: false,
      rgArray: [
        {
          name: "全部",
        },
        {
          name: "已认购",
        },
        {
          name: "未认购",
        },
        {
          name: "放弃认购",
        },
        {
          name: "作废",
        },
      ],
      xzqhDefault: this.main.getHostArea(),
      items: "",
    };
  },
  mounted() {
    // this.getArea();
    // var Img = this.logoImg;
    // var url = window.location.href;
    // var hosts = url.split("/#/")[0]; //获取域名加打包文件夹名称
    // var shareImg = hosts.concat("/" + Img);
    // this.$share(
    //   "徐州市商品房预售进度",
    //   "新建商品房预售办理进度实时查看，开盘进度及时掌握",
    //   shareImg
    // );
  },
  methods: {
    // 切换tab列表
    changeTab(type) {
      this.finished = false;
      this.list.length = 0;
      this.tab = type;
      if (type == 0) {
        this.definition = "人才";
      }
      if (type == 1) {
        this.definition = "无住房";
      }
      if (type == 2) {
        this.definition = "普通";
      }
      this.loading = false;
      this.pageIndex = 1;
      this.onLoad(1);
    },
    goback() {
      this.$router.go(-1);
    },
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.pageIndex = 1;
      this.$set(this, "list", []);
      this.onLoad(1);
    },
    submit() {
      this.loading = false;
      this.finished = false;
      this.$set(this, "pageIndex", 1);
      this.$set(this, "list", []);
      this.onLoad(1);
    },
    onConfirm(data) {
      if (data.name == "全部") {
        this.state = data.name;
        this.choiceType = "";
      } else {
        this.choiceType = data.name;
        this.state = data.name;
      }
      this.showPicker = false;
      this.loading = false;
      this.finished = false;
      this.pageIndex = 1;
      this.$set(this, "list", []);
      this.onLoad(1);
    },
    // 获取默认的行政区划
    // getArea() {
    //   this.$new.post("xzqh/getXzqh.do").then((res) => {
    //     if (res.obj) {
    //       if (this.xzqhDefault === "320300") {
    //         this.xzqhArray = res.obj[0].xzqhs;
    //         this.items = { xzqh_code: "320300", xzqh_name: "主城区" };
    //         this.xzqhArray.splice(0, 0, this.items);
    //         this.area = "主城区";
    //       } else {
    //         res.obj.forEach((item) => {
    //           if (this.xzqhDefault === item.xzqh_code) {
    //             this.$set(this, "xzqhArray", [item]);
    //             this.area = item.xzqh_name;
    //           }
    //         });
    //       }
    //     }
    //   });
    // },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        this.$http
          .post(
            "house/api/ysbm/xfxhlist.do",
            qs.stringify({
              talentType: this.definition,
              pageSize: 10,
              pageIndex: this.pageIndex,
              userName: this.itemName,
              saleItemId: this.saleItemId,
              choiceType: this.choiceType,
            })
          )
          .then((res) => {
            if (type) {
              this.isLoading = false;
            }
            if (res.code == "000") {
              this.list = this.list.concat(res.rows);
              this.loading = false;
              this.$set(this, "pageIndex", this.pageIndex + 1);
              if (res.rows.length == 0) {
                this.finished = true;
              }
            } else {
              this.finished = true;
            }
          });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tab_con {
  height: 1rem;
  background-color: #fff;
  z-index: 9;
  span {
    font-weight: 800;
    font-size: 0.25rem;
    margin: 0.3rem;
    position: relative;
  }
  .active {
    color: #3072f5;
    font-size: 0.3rem;
    &:after {
      content: "";
      bottom: -0.2rem;
      position: absolute;
      display: block;
      left: 50%;
      margin-left: -0.2rem;
      background-color: #3072f5;
      width: 0.4rem;
      height: 0.04rem;
    }
  }
}
.fixed_pad {
  padding-top: 1.1rem;
}
.main_other {
  margin-top: 20px;
}
.fixed_pad_new {
  padding-top: 1.5rem;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.header_address {
  font-size: 0.28rem;
  font-weight: 600;
  cursor: pointer;
  &.white {
    &:after {
      border-color: #fff transparent transparent transparent;
    }
  }
  &:after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0.08rem;
    margin-left: 0.1rem;
    margin-top: 0.08rem;
    border-color: #202020 transparent transparent transparent;
  }
}
.top_header {
  height: 0.7rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
  &.top_sm {
    padding: 0.1rem;
  }
  .search_con,
  .search_con_l {
    background-color: #f6f6f6;
    border: 1px solid #f0f0f0;
    border-radius: 0.7rem;
    height: 0.7rem;
    box-sizing: border-box;
    font-size: 0.26rem;
    padding: 0 0.3rem;
    color: #303030;
    i {
      font-size: 0.36rem;
      margin-right: 0.2rem;
    }
  }
  input {
    width: 80%;
    height: 0.7rem;
    background-color: transparent;
  }
  .search_con {
    width: 3.7rem;
  }
  .search_con_l {
    width: 5.72rem;
  }
  .to_map {
    font-size: 0.28rem;
    img {
      margin-right: 0.06rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
.bg_gray {
  min-height: 100vh;
  background-color: #f5f5f5;
}
.inner {
  padding: 0.24rem 0.24rem;
  background-color: #fff;
}
.top {
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 0.2rem;
  margin-bottom: 0.12rem;
  h5 {
    font-size: 0.26rem;
    font-weight: 800;
    max-width: 70%;
  }
  p {
    font-size: 0.24rem;
    span {
      color: #2f72f5;
    }
  }
}
.row {
  &:last-child {
    padding-bottom: 0;
  }
  padding-bottom: 0.12rem;
  p {
    line-height: 0.36rem;
    color: #808080;
    font-size: 0.24rem;
    span {
      max-width: 80%;
      color: #101010;
    }
  }
}
.bor_b {
  border-bottom: 0.1rem solid #f5f5f5;
}
</style>